module.exports = __webpack_public_path__ + "5ce453cbcd4336af2a688c215a6b105b.png";